import { Component, OnInit } from '@angular/core';
import {ReturnRemarkComponent} from '../../approval-process/return-remark/return-remark.component';
import {FwdRemarkComponent} from '../../approval-process/fwd-remark/fwd-remark.component';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ApprovalModel} from '../../shared/dto/approval.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RemarkComponent} from '../../approval-process/remark/remark.component';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {ApprovalService} from '../../service/approval.service';
import {ActivatedRoute} from '@angular/router';
import {ReversedBlacklistService} from '../../shared/service/reversed-blacklist.service';
import {BlacklistApproveChecklistComponent} from '../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {ActionMode} from '../../shared/enums/action-mode.enum';
import {WorkflowEnum} from '../../shared/enums/workflow.enum';

@Component({
  selector: 'app-reversed-process-request-viewer',
  templateUrl: './reversed-process-request-viewer.component.html',
  styleUrls: ['./reversed-process-request-viewer.component.scss']
})
export class ReversedProcessRequestViewerComponent implements OnInit {
  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal, private blackListService: ReversedBlacklistService) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.RETURN;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.APPROVE;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.BLACKLIST_REVERSED;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

}
